import { AsyncComponent } from '@frontend/components/mobile';
import { lazy } from 'react';
import { Navigate, Route } from 'react-router-dom';

import { ActivityRoutes } from './activity/activity-routes';
import TransactionDetail from './activity/transaction-detail/transaction-detail.component';

const Home = lazy(() => import('./home/home.component'));

export function NivalizRoutes() {
    const activityRoutes = ActivityRoutes();
    return (
        <Route path='nivaliz'>
            {activityRoutes}
            <Route
                index
                element={<Navigate to='home' />}
            />
            <Route path='home'>
                <Route
                    index
                    element={
                        <AsyncComponent>
                            <Home />
                        </AsyncComponent>
                    }
                />
            </Route>
            <Route path='transaction'>
                <Route path=':transactionId'>
                    <Route
                        path='detail'
                        element={
                            <AsyncComponent>
                                <TransactionDetail />
                            </AsyncComponent>
                        }
                    />
                </Route>
            </Route>
        </Route>
    );
}
